module.exports = __webpack_public_path__ + "static/media/search_icon.6b616ec1.svg";